<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">15. </span>
                What companies, wholesalers, and MGA's do you do business with?
              </label>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <label for class="orep-label">
                Name
              </label>
              <input
                  type="text"
                  id="businessCompanyNameOne"
                  name="businessCompanyNameOne"
                  v-model="insuranceAgentApplication.businessCompanyNameOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('businessCompanyNameOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('businessCompanyNameOne') | filterText }}</span>
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Percentage of Business
              </label>
              <input
                  type="text"
                  id="businessPercentageOne"
                  name="businessPercentageOne"
                  v-model="insuranceAgentApplication.businessPercentageOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('businessPercentageOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('businessPercentageOne') | filterText }}</span>
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Admitted
              </label>
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedOne"
                        id="businessAdmittedOneYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedOne"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedOne"
                        id="businessAdmittedOneNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-validate="'required'"
                        v-model="insuranceAgentApplication.businessAdmittedOne"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('businessAdmittedOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('businessAdmittedOne') | filterText }}</span>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameTwo"
                  name="businessCompanyNameTwo"
                  v-model="insuranceAgentApplication.businessCompanyNameTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageTwo"
                  name="businessPercentageTwo"
                  v-model="insuranceAgentApplication.businessPercentageTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedTwo"
                        id="businessAdmittedTwoYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedTwo"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedTwo"
                        id="businessAdmittedTwoNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedTwo"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameThree"
                  name="businessCompanyNameThree"
                  v-model="insuranceAgentApplication.businessCompanyNameThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageThree"
                  name="businessPercentageThree"
                  v-model="insuranceAgentApplication.businessPercentageThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedThree"
                        id="businessAdmittedThreeYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedThree"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedThree"
                        id="businessAdmittedThreeNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedThree"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameFour"
                  name="businessCompanyNameFour"
                  v-model="insuranceAgentApplication.businessCompanyNameFour"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageFour"
                  name="businessPercentageFour"
                  v-model="insuranceAgentApplication.businessPercentageFour"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedFour"
                        id="businessAdmittedFourYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedFour"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedFour"
                        id="businessAdmittedFourNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedFour"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameFive"
                  name="businessCompanyNameFive"
                  v-model="insuranceAgentApplication.businessCompanyNameFive"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageFive"
                  name="businessPercentageFive"
                  v-model="insuranceAgentApplication.businessPercentageFive"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedFive"
                        id="businessAdmittedFiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedFive"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedFive"
                        id="businessAdmittedFiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedFive"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameSix"
                  name="businessCompanyNameSix"
                  v-model="insuranceAgentApplication.businessCompanyNameSix"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageSix"
                  name="businessPercentageSix"
                  v-model="insuranceAgentApplication.businessPercentageSix"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedSix"
                        id="businessAdmittedSixYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedSix"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedSix"
                        id="businessAdmittedSixNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedSix"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameSeven"
                  name="businessCompanyNameSeven"
                  v-model="insuranceAgentApplication.businessCompanyNameSeven"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageSeven"
                  name="businessPercentageSeven"
                  v-model="insuranceAgentApplication.businessPercentageSeven"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedSeven"
                        id="businessAdmittedSevenYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedSeven"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedSeven"
                        id="businessAdmittedSevenNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedSeven"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-auto d-flex flex-column align-items-center">
              <input
                  type="text"
                  id="businessCompanyNameEight"
                  name="businessCompanyNameEight"
                  v-model="insuranceAgentApplication.businessCompanyNameEight"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="businessPercentageEight"
                  name="businessPercentageEight"
                  v-model="insuranceAgentApplication.businessPercentageEight"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedEight"
                        id="businessAdmittedEightYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedEight"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="businessAdmittedEight"
                        id="businessAdmittedEightNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.businessAdmittedEight"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </article>

        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">16.</span>
                Are you a member of an insurance network, cluster, or aggregator?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="insuranceNetwork"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.insuranceNetwork"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="insuranceNetwork"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.insuranceNetwork"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('insuranceNetwork')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('insuranceNetwork') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.insuranceNetwork == true || insuranceAgentApplication.insuranceNetwork === 'true'">
            <label class="orep-label text-danger">If Yes, provide list
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.insuranceNetwork == true || insuranceAgentApplication.insuranceNetwork === 'true'"
                name="insuranceNetworkDetails"
                v-model="insuranceAgentApplication.insuranceNetworkDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">  BUSINESS OPERATIONS </h1>
        </article>

        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">17.</span>
                Are you controlled, owned, affiliated, or associated with any other firm, business, agency, corporation, or insurance company?              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownOtherFirm"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownOtherFirm"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownOtherFirm"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.ownOtherFirm"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('ownOtherFirm')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownOtherFirm') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.ownOtherFirm == true || insuranceAgentApplication.ownOtherFirm === 'true'">
            <label class="orep-label text-danger">If Yes, provide details
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.ownOtherFirm == true || insuranceAgentApplication.ownOtherFirm === 'true'"
                name="ownOtherFirmDetails"
                v-model="insuranceAgentApplication.ownOtherFirmDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">18.</span>
                During the past 3 years has the name of your agency changed or has any other business or agency been acquired, merged into, or consolidated with you?</label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="past3YearsAgencyNameChanged"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.past3YearsAgencyNameChanged"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="past3YearsAgencyNameChanged"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.past3YearsAgencyNameChanged"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('past3YearsAgencyNameChanged')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('past3YearsAgencyNameChanged') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.past3YearsAgencyNameChanged == true || insuranceAgentApplication.past3YearsAgencyNameChanged === 'true'">
            <label class="orep-label text-danger">If Yes, provide details
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.past3YearsAgencyNameChanged == true || insuranceAgentApplication.past3YearsAgencyNameChanged === 'true'"
                name="past3YearsAgencyNameChangedDetails"
                v-model="insuranceAgentApplication.past3YearsAgencyNameChangedDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">19.</span>
                Do you accept any business from other agents?              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="acceptBusinessFromOtherAgents"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.acceptBusinessFromOtherAgents"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="acceptBusinessFromOtherAgents"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.acceptBusinessFromOtherAgents"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('acceptBusinessFromOtherAgents')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('acceptBusinessFromOtherAgents') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.acceptBusinessFromOtherAgents == true || insuranceAgentApplication.acceptBusinessFromOtherAgents === 'true'">
            <label class="orep-label text-danger">If Yes, provide details
            </label>

            <input
                type="text"
                placeholder="Please explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.acceptBusinessFromOtherAgents == true || insuranceAgentApplication.acceptBusinessFromOtherAgents === 'true'"
                name="acceptBusinessFromOtherAgentsDetails"
                v-model="insuranceAgentApplication.acceptBusinessFromOtherAgentsDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">20.</span>
                Is all incoming mail date stamped the date it is received?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="incomingMailStamped"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.incomingMailStamped"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="incomingMailStamped"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.incomingMailStamped"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('incomingMailStamped')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('incomingMailStamped') | filterText }}</span>
            </div>
          </div>
        </article>

        <article class="input-section form-section">
          <div class="row">
            <div class="col-md-4">
              <label for class="orep-label">
                <span class="mr-1">21.</span> How long do you maintain your records?
              </label>
            </div>
            <div class="col-md-4">
              <input
                  type="text"
                  name="howLongMaintainRecords"
                  v-model="insuranceAgentApplication.howLongMaintainRecords"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('howLongMaintainRecords')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('howLongMaintainRecords') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label">
                Years
              </label>
            </div>
          </div>
        </article>


        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">22.</span>
                Do you maintain a binder log?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="maintainBinderLog"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.maintainBinderLog"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="maintainBinderLog"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.maintainBinderLog"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('maintainBinderLog')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('maintainBinderLog') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">23.</span>
                Do you document all business related conversations?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="documentAllBusinessConversations"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.documentAllBusinessConversations"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="documentAllBusinessConversations"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.documentAllBusinessConversations"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('documentAllBusinessConversations')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('documentAllBusinessConversations') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">24.</span>
                Do you require requests from your customers that coverage be increased, reduced, or eliminated be in writing?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="coverageChangeRequest"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.coverageChangeRequest"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="coverageChangeRequest"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.coverageChangeRequest"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('coverageChangeRequest')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('coverageChangeRequest') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">25.</span>
                Do you require customers to acknowledge, in writing, the declination of uninsured/underinsured auto, earthquake, flood, wind, or other coverages that you suggest?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="acknowledgeDisaster"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.acknowledgeDisaster"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="acknowledgeDisaster"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.acknowledgeDisaster"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('acknowledgeDisaster')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('acknowledgeDisaster') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">26.</span>
                Do you use a "Power of Attorney" to represent the insured?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="doYouUsePowerOfAttorney"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.doYouUsePowerOfAttorney"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="doYouUsePowerOfAttorney"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.doYouUsePowerOfAttorney"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('doYouUsePowerOfAttorney')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouUsePowerOfAttorney') | filterText }}</span>
            </div>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">27.</span>
                Have any companies, general agents, or other markets withdrawn from you agency in the last 3 years?              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="withdrawnFromAgencyLast3Years"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.withdrawnFromAgencyLast3Years"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="withdrawnFromAgencyLast3Years"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.withdrawnFromAgencyLast3Years"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('withdrawnFromAgencyLast3Years')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('withdrawnFromAgencyLast3Years') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.withdrawnFromAgencyLast3Years == true || insuranceAgentApplication.withdrawnFromAgencyLast3Years === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.withdrawnFromAgencyLast3Years == true || insuranceAgentApplication.withdrawnFromAgencyLast3Years === 'true'"
                name="withdrawnFromAgencyLast3YearsDetails"
                v-model="insuranceAgentApplication.withdrawnFromAgencyLast3YearsDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">28.</span>
                Do you have binding Authority            </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveBindingAuthority"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.haveBindingAuthority"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="haveBindingAuthority"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.haveBindingAuthority"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('haveBindingAuthority')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('haveBindingAuthority') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.haveBindingAuthority == true || insuranceAgentApplication.haveBindingAuthority === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.haveBindingAuthority == true || insuranceAgentApplication.haveBindingAuthority === 'true'"
                name="haveBindingAuthorityDetails"
                v-model="insuranceAgentApplication.haveBindingAuthorityDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">  CLAIMS AND PRIOR COVERAGE  </h1>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">29.</span>
                Do you currently have E&O Coverage?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="eoCoverage"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.eoCoverage"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="eoCoverage"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.eoCoverage"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('eoCoverage')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('eoCoverage') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.eoCoverage == true || insuranceAgentApplication.eoCoverage === 'true'">
            <label class="orep-label text-danger">A. If you are new to IBDPro, please send a copy of your Expiring Dec Page to <a href="mailto:service@ibdpro.com">service@ibdpro.com</a>
            </label>
          </div>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="row">
            <div class="col-md-9 col-sm-12">
              <label for class="orep-label">
                <span class="mr-1">30.</span>
                Has your insurance every been cancelled renewal refused, or coverage declined:
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="insuranceRenewalCancelled"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.insuranceRenewalCancelled"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="insuranceRenewalCancelled"
                        value="false"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="insuranceAgentApplication.insuranceRenewalCancelled"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('insuranceRenewalCancelled')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('insuranceRenewalCancelled') | filterText }}</span>
            </div>
          </div>
          <div class="col-md-auto d-flex flex-column" v-if="insuranceAgentApplication.insuranceRenewalCancelled == true || insuranceAgentApplication.insuranceRenewalCancelled === 'true'">
            <label class="orep-label text-danger">If yes, explain
            </label>

            <input
                type="text"
                placeholder="Please Explain:"
                class="orep-text-input js-orep-input"
                v-if="insuranceAgentApplication.insuranceRenewalCancelled == true || insuranceAgentApplication.insuranceRenewalCancelled === 'true'"
                name="insuranceRenewalCancelledDetails"
                v-model="insuranceAgentApplication.insuranceRenewalCancelledDetails"
                @input="validateBeforeSubmit()"
            >
          </div>
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ibdpro-insurance-agent-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-insurance-agent-application-4')" :disabled="!state.pageThreeIsValid"></button>
              <button class="pagination-dots" @click="navigateToNext('ibdpro-insurance-agent-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
              <button
                  class="pagination-dots"
                  :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid|| !state.pageFiveIsValid"
                  @click="navigateToNext('ibdpro-insurance-agent-application-6')">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('ibdpro-insurance-agent-application-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "ibdpro-insurance-agent-application-3",
  computed: {
    insuranceAgentApplication() {
      return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
    },
    state() {
      return this.$store.state.insuranceAgentApplication;
    },
    errorMsg() {
      return this.$store.state.insuranceAgentApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.insuranceAgentApplication.limitOfCoverages.find(coverage => coverage === event.target.value)) {
        if (this.insuranceAgentApplication.limitOfCoverages.length < 2) {
          this.insuranceAgentApplication.limitOfCoverages.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 2 coverages.'
          });
        }
      } else {
        this.insuranceAgentApplication.limitOfCoverages = this.insuranceAgentApplication.limitOfCoverages.filter(coverage => coverage !== event.target.value);
      }
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    prev() {
      this.$router.push({
        name: "ibdpro-insurance-agent-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "ibdpro-insurance-agent-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.insuranceAgentApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
            this.state.pageTwoIsValid = false;
            this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },

    totalPercentage(){
      return (parseFloat(this.state.insuranceAgentApplication.personalAuto) + parseFloat(this.state.insuranceAgentApplication.personalHomeowners) +
          parseFloat(this.state.insuranceAgentApplication.personalOther) +
          parseFloat(this.state.insuranceAgentApplication.commercialAuto) +
          parseFloat(this.state.insuranceAgentApplication.commercialProperty) +
          parseFloat(this.state.insuranceAgentApplication.commercialLiability) +
          parseFloat(this.state.insuranceAgentApplication.commercialPackage) +
          parseFloat(this.state.insuranceAgentApplication.commercialWorker) +
          parseFloat(this.state.insuranceAgentApplication.commercialOther) +
          parseFloat(this.state.insuranceAgentApplication.kindOfBusinessLife) +
          parseFloat(this.state.insuranceAgentApplication.kindOfBusinessHealth) +
          parseFloat(this.state.insuranceAgentApplication.kindOfBusinessOther))
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    this.validateBeforeSubmit();
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
.red-text {
  color: red;
}
</style>

